import React from 'react';
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DomainIcon from "@mui/icons-material/Domain";
import { useNavigate } from "react-router-dom";
import styles from './FinancialHub.module.css';
import globalStyles from '../../../assets/styles/LayoutShared.module.css';
import { ArrowBack } from '@mui/icons-material';
import Button from '../../../components/Button/Button';

const FinancialHub = () => {
  const navigate = useNavigate();

  const menuOptions = [
    {
      title: "Plano de Contas",
      onClick: () => {
        navigate("/agro/financialHub/chartOfAccounts");
      },
      icon: <AccountTreeIcon sx={{ fontSize: 50 }} />,
    },
    {
      title: "Centro de Custos",
      onClick: () => {
        navigate("/agro/financialHub/costCenters");
      },
      icon: <DomainIcon sx={{ fontSize: 50 }} />,
    },
    {
      title: "Contas Financeiras",
      onClick: () => {
        navigate("/agro/financialHub/financialAccounts");
      },
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 50 }} />,
    },
  ];

  return (
    <div className={globalStyles.container}>
      <div className={globalStyles.headerTitle}>
        <h1 className={globalStyles.greenTitle}>Configurações Financeiras</h1>
        
        <Button variant="contain" title="Voltar para página anterior" onClick={() => navigate(-1)}>
          <ArrowBack />
        </Button>
      </div>

      <div className={styles.cardGrid}>
        {menuOptions.map((option, index) => (
          <div
            key={index}
            className={styles.navCard}
            onClick={option.onClick}
          >
            <div className={styles.iconContainer}>{option.icon}</div>
            <span className={styles.cardTitle}>{option.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FinancialHub;